import { IUserData } from './IUserData';
import { BasicUserInfoModel } from "./BasicUserInfoModel";
import { IFramework, IWebServiceManager, HttpMethod, IWebServiceRequest } from '@truckdown/framework';


class UserData implements IUserData {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;

    private internalGetUsersInfo(request: IWebServiceRequest): Promise<BasicUserInfoModel[]> {
        return new Promise<BasicUserInfoModel[]>((resolve, reject) => {
            this.manager
                .get<BasicUserInfoModel[]>(request)
                .then((res) => {
                    resolve((res as BasicUserInfoModel[]));
                })
                .catch((err) => {
                    console.log(err);
                    resolve([]);
                })
        });
    }

    profileImagePath(imageId: string): string {
        return '/accounts/user/profile-image/' + encodeURIComponent(imageId);
    }

    getUsersInfo(userIds: string[] | number): Promise<BasicUserInfoModel[]> {
        if (Array.isArray(userIds)) {
            return this.internalGetUsersInfo(this.manager.createRequest({
                service: this.manager.api,
                path: '/accounts/user/get-users-info',
                method: HttpMethod.PUT
            }, userIds));
        } else {
            return this.internalGetUsersInfo(this.manager.createRequest({
                service: this.manager.api,
                path: '/accounts/user/get-users-info/' + encodeURIComponent(userIds),
                method: HttpMethod.GET
            }));
        }
    }

    getUserId(username: string): Promise<BasicUserInfoModel | null> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/user/get-user-id/' + encodeURIComponent(username),
            method: HttpMethod.GET
        });

        return new Promise<BasicUserInfoModel | null>((resolve, reject) => {
            this.manager
                .get<BasicUserInfoModel | null>(request)
                .then((res) => {
                    resolve((res as BasicUserInfoModel));
                })
                .catch((err) => {
                    console.log(err);
                    resolve(null);
                })
        });
    }

    getUserInfo(userId: string): Promise<BasicUserInfoModel | null> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/user/get-user-info/' + encodeURIComponent(userId),
            method: HttpMethod.GET
        });

        return new Promise<BasicUserInfoModel | null>((resolve, reject) => {
            this.manager
                .get<BasicUserInfoModel | null>(request)
                .then((res) => {
                    resolve((res as BasicUserInfoModel));
                })
                .catch((err) => {
                    console.log(err);
                    resolve(null);
                })
        });
    }
}

export default (framework: IFramework) => {
    framework.registerTransient<IUserData>('IUserData', (frm) => {
        return new UserData(frm);
    });
}